<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-card class="elevation-12">
          <v-card-title> Starred Todos </v-card-title>
          <v-card-subtitle> Starred: {{ todos.length }}</v-card-subtitle>
          <v-card-text>
            <TodoList
              :todoType="'Starred'"
              :todos="todos"
              :search-query="searchQuery"
              :empty-list-image="
                require('../assets/images/prioritise-tasks.svg')
              "
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TodoList from '../components/TodoList'

export default {
  name: 'Starred',
  components: {
    TodoList,
  },
  computed: {
    todos: function () {
      return this.$store.getters.starredTodos
    },
  },
  props: {
    searchQuery: {
      type: String,
      default: '',
    },
  },
}
</script>

<style></style>
